// pages/TempoGarantia.jsx
import React from 'react';

export default function TempoGarantia() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Tempo de Garantia</h1>
      <p>As garantias são fornecidas pelos fabricantes e podem variar de acordo com o produto, sendo detalhadas nas páginas individuais de cada item. Em caso de dúvidas, estamos à disposição para esclarecimentos.</p>
    </div>
  );
}